import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { Stack, Button, InputLabel, Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useMultipleSelection } from "../../../Utils/Hooks/useMultipleSelection";
import { orderService } from "../../../Core/Api/services";

export type ModalResendTransferEmailElementProps = {
  itemId: number;
  fileTransferEmails: string[];
};

export type ModalResendTransferEmailProps = CommonModalProps<ModalResendTransferEmailElementProps>;

const ModalResendTransferEmail = forwardRef<any, ModalResendTransferEmailProps>((props, ref) => {
  const { itemId, fileTransferEmails, closeModal } = props;

  const { selected, setSelectedList } = useMultipleSelection(fileTransferEmails, fileTransferEmails);

  const { t } = useTranslation();
  const enqueueCustomSnackbar = useCustomSnackbar();

  const onConfirm = () => {
    orderService.ResendTransferEmail({ itemId, recipientsToResend: selected }).then((response) => {
      if (response.success) {
        enqueueCustomSnackbar(t("alert:success.successResendTransferEmail"), "success");
        closeModal();
      } else {
        enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "error");
      }
    });
  };

  return (
    <Modal
      title={t("menu:title.resendTransferEmail")}
      reference={ref}
      closeModal={closeModal}
      width={600}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:cancel")}
          </Button>
          <Button variant="outlined" color="success" disabled={selected.length === 0} onClick={onConfirm}>
            {t("common:resend")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={0}>
        <InputLabel>{t("form:label.selectEmails")}</InputLabel>
        <Autocomplete
          options={fileTransferEmails}
          multiple
          value={selected}
          onChange={(event, newValue) => {
            setSelectedList(newValue);
          }}
          renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
        />
      </Stack>
    </Modal>
  );
});

export default ModalResendTransferEmail;
